exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#intern_btn[data-v-481cf2bf] {\n  line-height: 35px;\n}\n@media (min-width: 768px) {\n#intern_btn[data-v-481cf2bf] {\n    top: -50px;\n    right: 0;\n}\n}\n@media (max-width: 768px) {\n#intern_btn[data-v-481cf2bf] {\n    display: inline-block;\n}\n}", ""]);

// exports
